import { useCallback } from "react";
import api from "@/lib/api";
import { useSyncedForm, withDefaults } from "@/hooks/settings/useSettingsDoc";
import { saveWithToast, withoutEmpty } from "@/hooks/settings/saveWithToast";

const smtpForm = (data) => ({
  ...withDefaults(data?.smtp, { host: "", port: 587, user: "", from_address: "" }),
  password: "",
  use_tls: data?.smtp?.use_tls ?? true,
});

const brandingForm = (data) => data?.branding || {};

const syncForm = (data) => withDefaults(data?.sync, { auto_sync_enabled: false, interval_minutes: 60 });

const syncMessage = ({ data }) => (data.next_run
  ? `Sincronización activa. Próxima ejecución: ${new Date(data.next_run).toLocaleString("es")}`
  : "Sincronización automática desactivada");

export function useSmtpSettings(settings, reload) {
  const [smtp, setSmtp] = useSyncedForm(settings, smtpForm);
  const saveSmtp = useCallback(() => saveWithToast(
    () => api.put("/settings/smtp", withoutEmpty(smtp, "password")), "SMTP actualizado", reload,
  ), [smtp, reload]);
  return { smtp, setSmtp, saveSmtp };
}

export function useBrandingSettings(settings, reload) {
  const [branding, setBranding] = useSyncedForm(settings, brandingForm);
  const saveBranding = useCallback(() => saveWithToast(
    () => api.put("/settings/branding", branding), "Identidad corporativa actualizada", reload,
  ), [branding, reload]);
  return { branding, setBranding, saveBranding };
}

export function useSyncSettings(settings, reload) {
  const [sync, setSync] = useSyncedForm(settings, syncForm);
  const saveSync = useCallback(() => saveWithToast(
    () => api.put("/settings/sync", sync), syncMessage, reload,
  ), [sync, reload]);
  return { sync, setSync, saveSync };
}
